module.exports = __webpack_public_path__ + "img/1f960.c7dfcf3.svg";